module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/kPoRnJ/tc-custom/9781446352496.jpg?1740170030006",
      "alt": "This image is the cover for the book Landscapes, The Digital SLR Expert"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Landscapes, The Digital SLR Expert\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("HEADLINE:  Build and Refine Your In-Camera and Photoshop Skills with This Authoritative and Visually Stunning Guide to Capturing Incredible Landscape Photographs    Practical demonstrations, step-by-step examples and invaluable secrets from five leading professional photographers show you how to use your digital SLR to its full potential    Darwin Wiggett, David Noton, William Neill, Tom Mackie and Tony Worobiec tackle subjects key to taking great landscape images: controlling exposure; understanding light; composing shots; choosing the perfect location and working in black and white    Breathtaking photography showcases a wide variety of landscape locations from coasts to mountains, cities to countryside and deserts to forests, highlighting the versatility and full potential of digital photography")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Tom Mackie, William Neill, David Noton, Darwin Wiggett, Tony Worobiec\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0